import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Downloads from '../views/Downloads.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'home',
		component: Home
	},
	{
		path: '/downloads/:id',
		name: 'downloads',
		component: Downloads,
		props: (route) => ({ query: route.query.q })
	}
]

const router = new VueRouter({
	routes
})

export default router
